// extracted by mini-css-extract-plugin
export default {"voiceMailIcon":"StudentVoiceMailListView_voiceMailIcon__EPqs8","voiceMailRead":"StudentVoiceMailListView_voiceMailRead__mI22R"};